import React, { useEffect, useState } from "react";
import { CssBaseline, Divider } from "@material-ui/core";

import "./Header.css";
import axios from "axios";

import SingleItem from "./singleItem/SingleItem";

const Header = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [content, setContent] = useState();
  const [page, setpage] = useState();
  const fetchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/search/${
        "tv" || "movie"
      }?api_key=49ee1b42258c9faabeec54190b777a93&language=en-US&query=${searchTerm}&page=${page}&include_adult=false`
    );
    setContent(data.results);
  };

  useEffect(() => {
    fetchData();
  }, [page]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm) {
      fetchData();
      setSearchTerm("");
    }
  };
  return (
    <>
      <CssBaseline />

      <header className="header">
        <h4>Garrison Empire</h4>
        <div>
          <form onSubmit={handleSubmit} className="searchForm">
            <input
              type="text"
              name=""
              id=""
              placeholder="Search"
              className="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </form>
        </div>
      </header>
      <div>
        <div className="trending">
          {content &&
            content.map((c) => (
              <SingleItem
                key={c.id}
                id={c.id}
                poster_path={c.poster_path}
                title={c.title || c.name}
                date={c.first_air_date || c.release_date}
                media_type="tv"
                vote_average={c.vote_average}
              />
            ))}
        </div>
      </div>
      <Divider />
    </>
  );
};

export default Header;
